import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OperatorShell } from './components/layout/OperatorShell';
import { Login } from './pages/Login';
import { TaskList } from './pages/TaskList';
import { TaskDetail } from './pages/TaskDetail';
import { TaskInProgress } from './pages/TaskInProgress';
import { Stats } from './pages/Stats';
import { Profile } from './pages/Profile';
import { NetworkStatus } from './components/ui/NetworkStatus';
import { isRTL } from './i18n';

export default function App() {
  const { i18n } = useTranslation();
  const dir = isRTL(i18n.language) ? 'rtl' : 'ltr';
  // Mock user data - will be replaced with auth context
  const userName = 'John';
  const notificationCount = 3;
  const isAuthenticated = true; // Will come from auth context

  if (!isAuthenticated) {
    return (
      <div dir={dir} className="min-h-screen">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div dir={dir} className="min-h-screen">
      <Routes>
        {/* Task in progress - full screen, no shell */}
        <Route path="/tasks/:id/active" element={<TaskInProgress />} />

        {/* Main app with shell */}
        <Route
          element={
            <OperatorShell
              userName={userName}
              notificationCount={notificationCount}
            />
          }
        >
          <Route path="/" element={<Navigate to="/tasks" replace />} />
          <Route path="/tasks" element={<TaskList />} />
          <Route path="/tasks/:id" element={<TaskDetail />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Routes>
      <NetworkStatus />
    </div>
  );
}
